import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { reportError } from '@gift/common/helpers/logging';

const resources = {
    'en-US': { translation: require('./en-US.json') },
    'fr-BE': { translation: require('./fr-BE.json') },
    'nl-NL': { translation: require('./nl-NL.json') },
};

export const createI18n = (language: string) => {

    const options = {
        lng: language,
        fallbackLng: 'en-US',
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
        resources
    };

    i18next
        .use(initReactI18next)
        .init(options)
        .catch(reportError);

    return i18next;
};
